var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { compose, EditableDynamicTable, EditablePage, EditableQuerySelect, EditableTextField, graphql, returnError, Spinner, useMutation, withGraphqlErrorFlags, withLoadingSpinner, withShowFlag, } from "@atlassiansox/microscopekit";
import { EditableContext } from "@atlassiansox/microscopekit/dist/src/editable/editable-context";
import { formatDistanceToNow } from "date-fns";
import noop from "lodash/noop";
import * as React from "react";
import { lifecycle } from "recompose";
import styled from "styled-components";
import { Permission, } from "../../../__generated__/graphql-global-types";
import loggingDataV2Query from "../../graphql/loggingDataV2.query.graphql";
import updateLoggingDataMutation from "../../graphql/updateLoggingData.mutation.graphql";
import usersQuery from "../../graphql/users.query.graphql";
import { asClassComponent } from "../../utils/reactLib";
import formValidators from "../../utils/validate";
import ErrorSection from "./ErrorSection";
import ServiceLoggingData from "./ServiceLoggingData";
import { ViewLogs } from "./SplunkLogs";
var EMPTY_ACLS = [];
var LastUpdatedAtViewMode = asClassComponent(function (_a) {
    var value = _a.value;
    return value ? React.createElement("em", null,
        formatDistanceToNow(new Date(value)),
        " ago") : null;
});
var LastUpdatedAtEditMode = asClassComponent(function (_a) {
    var defaultValue = _a.defaultValue;
    return (React.createElement(LastUpdatedAtViewMode, { value: defaultValue }));
});
var LastUpdatedByViewMode = asClassComponent(function (_a) {
    var value = _a.value;
    return value ? React.createElement("strong", null, value) : null;
});
var LastUpdatedByEditMode = asClassComponent(function (_a) {
    var defaultValue = _a.defaultValue;
    return (React.createElement(LastUpdatedByViewMode, { value: defaultValue }));
});
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var ContainerItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var LoggingForm = function (_a) {
    var _b, _c, _d, _e, _f;
    var id = _a.id, data = _a.data, loggingId = _a.loggingId, microscopePermission = _a.microscopePermission, environments = _a.environments, showFlag = _a.showFlag;
    var defaultUser = React.useMemo(function () {
        var _a, _b, _c, _d;
        return ({
            label: (_b = (_a = data.loggingDataV2) === null || _a === void 0 ? void 0 : _a.owner) !== null && _b !== void 0 ? _b : "",
            value: (_d = (_c = data.loggingDataV2) === null || _c === void 0 ? void 0 : _c.owner) !== null && _d !== void 0 ? _d : "",
        });
    }, [(_b = data.loggingDataV2) === null || _b === void 0 ? void 0 : _b.owner]);
    var defaultBusinessUnit = (_d = (_c = data.loggingDataV2) === null || _c === void 0 ? void 0 : _c.organization) !== null && _d !== void 0 ? _d : "";
    var loadUsers = React.useCallback(function (inputValue, query) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!inputValue)
                return [2 /*return*/, []];
            return [2 /*return*/, query({
                    query: usersQuery,
                    variables: {
                        query: inputValue,
                    },
                }).then(function (result) {
                    var _a, _b;
                    return ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.users.map(function (user) { return ({
                        label: "" + user.username + (user.displayName ? " (" + user.displayName + ")" : ""),
                        value: user.username,
                    }); })) !== null && _b !== void 0 ? _b : []);
                })];
        });
    }); }, []);
    var acls = (_f = (_e = data.loggingDataV2) === null || _e === void 0 ? void 0 : _e.acls) !== null && _f !== void 0 ? _f : EMPTY_ACLS;
    var aclsWithKey = React.useMemo(function () { return acls.map(function (acl) { return (__assign(__assign({}, acl), { key: acl.acl_id.toString() })); }); }, [acls]);
    var createNewACL = React.useCallback(function () { return ({
        acl_id: null,
        environments: "",
        staffid_group: "",
        last_modified_timestamp: 0,
        last_modified_user: "",
        key: Date.now().toString(),
    }); }, []);
    var aclsTableFields = React.useMemo(function () { return [
        {
            key: "environments",
            headContent: "Environments",
            isEditable: function () { return true; },
            isSortable: true,
            validate: function (acl) {
                return formValidators.acl.environments(acl.environments, showFlag);
            },
        },
        {
            key: "staffid_group",
            headContent: "StaffID Group",
            shouldTruncate: true,
            isEditable: function () { return true; },
            isSortable: true,
            validate: function (acl) {
                return formValidators.acl.staffid_group(acl.staffid_group, showFlag);
            },
        },
        {
            key: "last_modified_timestamp",
            headContent: "Last updated at",
            shouldTruncate: true,
            isEditable: function () { return false; },
            isSortable: true,
            viewContent: React.createElement(LastUpdatedAtViewMode, null),
            editableContent: (React.createElement(LastUpdatedAtEditMode, { defaultValue: 0, isDisabled: true, onChange: noop })),
        },
        {
            key: "last_modified_user",
            headContent: "Last updated by",
            shouldTruncate: true,
            isEditable: function () { return false; },
            isSortable: true,
            viewContent: React.createElement(LastUpdatedByViewMode, null),
            editableContent: (React.createElement(LastUpdatedByEditMode, { defaultValue: "", isDisabled: true, onChange: noop })),
        },
    ]; }, [showFlag]);
    var save = useMutation(updateLoggingDataMutation)[0];
    var refetch = data.refetch;
    var onSave = React.useCallback(function (updatedValues) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, message, graphQLErrors, errorMessage;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 3, , 4]);
                    if (!data.loggingDataV2) {
                        throw new Error("Data not yet loaded");
                    }
                    return [4 /*yield*/, save({
                            variables: {
                                id: loggingId,
                                service: {
                                    name: data.loggingDataV2.name,
                                    organization: (_b = updatedValues.organization) !== null && _b !== void 0 ? _b : data.loggingDataV2.organization,
                                    owner: (_c = updatedValues.owner.value) !== null && _c !== void 0 ? _c : data.loggingDataV2.owner,
                                    source_id: (_d = updatedValues.source_id) !== null && _d !== void 0 ? _d : data.loggingDataV2.logging_id,
                                    acls: ((_e = updatedValues.acls) !== null && _e !== void 0 ? _e : data.loggingDataV2.acls).map(function (acl) { return ({
                                        acl_id: acl.acl_id,
                                        staffid_group: acl.staffid_group,
                                        environments: acl.environments,
                                    }); }),
                                    admins: (_f = updatedValues.admins) !== null && _f !== void 0 ? _f : data.loggingDataV2.admins,
                                    capacity_comment: data.loggingDataV2.capacity_comment,
                                    capacity_gigabytes: data.loggingDataV2.capacity_gigabytes,
                                },
                            },
                        })];
                case 1:
                    _g.sent();
                    return [4 /*yield*/, refetch()];
                case 2:
                    _g.sent();
                    showFlag({
                        type: "success",
                        title: "Success",
                        message: "Service logging metadata successfully updated.",
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _g.sent();
                    message = _a.message, graphQLErrors = _a.graphQLErrors;
                    errorMessage = returnError(graphQLErrors, message)[0];
                    showFlag({
                        type: "error",
                        title: "Error",
                        message: errorMessage,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [data.loggingDataV2, loggingId, refetch, save, showFlag]);
    return (React.createElement(EditablePage, { title: "Logging", onSave: onSave, isEditable: [Permission.Admin, Permission.Write].includes(microscopePermission) },
        data.loading && React.createElement(Spinner, null),
        !data.loading && !data.loggingDataV2 && React.createElement(ErrorSection, { id: id }),
        data.loggingDataV2 && (React.createElement(EditableContext.Consumer, null, function (_a) {
            var isEditMode = _a.isEditMode;
            return (
            // Some of the Microscope Kit components don't seem to reset properly after save, so force
            // React to delete and recreate this component tree when the data is updated.
            React.createElement(React.Fragment, { key: data.loggingDataV2.last_modified_timestamp + "-" + (isEditMode ? "edit" : "view") },
                React.createElement(Container, null,
                    React.createElement(ContainerItem, null,
                        React.createElement("h3", null, "General"),
                        React.createElement(EditableTextField, { name: "logging_id", label: "Logging ID", isDisabled: true, defaultValue: loggingId }),
                        React.createElement(EditableTextField, { name: "organization", label: "Organization", defaultValue: defaultBusinessUnit }),
                        React.createElement(EditableQuerySelect, { name: "owner", label: "Owner", loadOptions: loadUsers, defaultValue: defaultUser, validate: function (_a) {
                                var value = _a.value;
                                return formValidators.owner(value, showFlag);
                            } }),
                        React.createElement(EditableTextField, { name: "source_id", label: "Source ID", defaultValue: data.loggingDataV2.source_id, validate: function (_a) {
                                var value = _a.value;
                                return formValidators.source_id(value, showFlag);
                            } }),
                        React.createElement(EditableTextField, { name: "admins", label: "Admin Group", defaultValue: data.loggingDataV2.admins, validate: function (_a) {
                                var value = _a.value;
                                return formValidators.admins(value, showFlag);
                            } })),
                    React.createElement(ContainerItem, null,
                        React.createElement("h3", null, "View Logs"),
                        React.createElement(ViewLogs, { environments: environments, serviceName: data.loggingDataV2.name, source: data.loggingDataV2.source_id }))),
                React.createElement(ServiceLoggingData, { id: id }),
                React.createElement("h3", null, "Access Control"),
                React.createElement(EditableDynamicTable, { name: "acls", fields: aclsTableFields, defaultValue: aclsWithKey, createNewItem: createNewACL, allowDelete: function () { return true; }, addButtonText: "Add", emptyView: React.createElement("p", null, "There is no access control configured for this service.") })));
        }))));
};
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export default compose(graphql(loggingDataV2Query, {
    options: function (_a) {
        var loggingId = _a.loggingId;
        return ({
            query: loggingDataV2Query,
            variables: { loggingId: loggingId },
        });
    },
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, lifecycle({
    componentDidMount: function () {
        // We must check this.props.data.error if we want to prevent uncaught errors
        // https://www.apollographql.com/docs/react/api/react/hoc/#dataerror
        if (!this.props.data.loading && !this.props.data.error) {
            this.props.data.refetch();
        }
    },
}))(LoggingForm);
var templateObject_1, templateObject_2;
